import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var DownloadCloud02 = function DownloadCloud02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m8 17 4 4m0 0 4-4m-4 4v-9m8 4.7428c1.2215-1.0088 2-2.5349 2-4.2428C22 9.4624 19.5376 7 16.5 7c-.2185 0-.4229-.114-.5339-.3023C14.6621 4.4848 12.2544 3 9.5 3 5.3579 3 2 6.3579 2 10.5c0 2.0661.8354 3.9371 2.187 5.2935"
    })
  }));
};
export default DownloadCloud02;